import { render, staticRenderFns } from "./PagamentoAprovadoRegistro.vue?vue&type=template&id=5fdb26e0&scoped=true"
import script from "./PagamentoAprovadoRegistro.vue?vue&type=script&lang=js"
export * from "./PagamentoAprovadoRegistro.vue?vue&type=script&lang=js"
import style0 from "./PagamentoAprovadoRegistro.vue?vue&type=style&index=0&id=5fdb26e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdb26e0",
  null
  
)

export default component.exports